export const isNodeDragTarget = (target: Element): boolean => {
	if (
		target.closest('.positioning-board-card button') !== null ||
		target.closest('.node-media-card__expand') !== null ||
		target.closest('.grounding-evidence-card__expand') !== null ||
		target.closest('.node-expandable-text__expand') !== null ||
		target.closest('.node-like-control') !== null
	) {
		return false;
	}

	return (
		target.classList.contains('node') ||
		target.classList.contains('img-div') ||
		target.classList.contains('video-div') ||
		target.classList.contains('node-input') ||
		// Media cards are HTML inside an SVG foreignObject. Drag events usually
		// originate on their preview/caption child rather than the card root.
		// Treat that whole body as draggable, while keeping the controls above
		// excluded by the early return.
		target.closest('.img-div') !== null ||
		target.closest('.video-div') !== null ||
		// Social posts are rendered as an HTML article inside a foreignObject as
		// well. Their card body should drag like every other Synthesise node;
		// the expand control remains excluded above.
		target.closest('.grounding-evidence-card') !== null ||
		target.closest('.pdf-node-card') !== null ||
		target.closest('.positioning-board-card') !== null ||
		target.closest('.move-connected') !== null
	);
};
